import { Navigate, useLocation } from "react-router-dom";

export default function MembershipRedirect() {
  const location = useLocation();
  // Redirect from /people/:pgaId/person/membership to /people/:pgaId/membership/overview
  const newPath = location.pathname.replace("/person/membership", "/membership/overview");
  return <Navigate to={`${newPath}${location.search}`} replace />;
}
